import React from 'react';
import { Globe, Languages } from 'lucide-react';

/**
 * LanguageBadge — Subtle indicator for translation availability.
 * Shows "Available in your language" when language_score > 0,
 * or an optional "Content in English" hint when score is 0.
 *
 * This component is DISPLAY-ONLY. It does NOT affect ranking or sorting.
 */
export const LanguageBadge = ({ languageScore, showFallbackHint = false, className = '' }) => {
  if (languageScore > 0) {
    return (
      <span
        data-testid="language-badge-available"
        className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-emerald-50 text-emerald-700 border border-emerald-200 ${className}`}
      >
        <Globe className="h-3 w-3" />
        Available in your language
      </span>
    );
  }

  if (showFallbackHint) {
    return (
      <span
        data-testid="language-badge-fallback"
        className={`inline-flex items-center gap-1 text-[11px] font-medium px-2 py-0.5 rounded-full bg-slate-50 text-slate-500 border border-slate-200 ${className}`}
      >
        <Languages className="h-3 w-3" />
        Content in English
      </span>
    );
  }

  return null;
};

/**
 * TranslatedFromEnglish — Label for offer/quote views.
 * Shows when viewing an offer in a non-English language.
 */
export const TranslatedFromEnglishBadge = ({ currentLanguage, className = '' }) => {
  if (!currentLanguage || currentLanguage === 'en') return null;

  return (
    <div
      data-testid="translated-from-english-badge"
      className={`inline-flex items-center gap-1.5 text-xs font-medium px-3 py-1.5 rounded-md bg-amber-50 text-amber-700 border border-amber-200 ${className}`}
    >
      <Languages className="h-3.5 w-3.5" />
      Translated from English
    </div>
  );
};

export default LanguageBadge;
